import React from "react";
import { useSelector } from "react-redux";

const FixedFooter = ({
  basketFooter,
  page,
  screen,
  children,
  showExtraSpace = true,
  containerStyleProps = {}, // { className, style }
  innerStyleProps = {},     // { className, style }
}) => {
  const { cart } = useSelector((state) => state?.cart);
  const hasCartItems = cart?.length > 0;
  const isBasket = basketFooter === true;
  const showOnPage = page === true && hasCartItems;

  const containerClass = page
    ? showOnPage
      ? "relative"
      : "hidden"
    : screen === "confirmLocation"
    ? "relative"
    : "relative h-20";

  const innerBaseClass = `fixed bottom-0 p-4 max-460 flex flex-wrap justify-between ${isBasket ? "z-10" : ""} ${showExtraSpace ? "" : ""}`;

  return (
    <div
      className={containerStyleProps?.className ?? containerClass}
      style={containerStyleProps?.style ?? {}}
    >
      <footer
        className={`${innerBaseClass} ${innerStyleProps?.className || ""}`}
        style={innerStyleProps?.style ?? {}}
      >
        {children}
      </footer>
    </div>
  );
};

export default FixedFooter;
